import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { getSessionsByUseCase } from '../../../services/teacherSession.service';
import UseCaseHistory from '../../UseCaseHistory/UseCaseHistory';
import { useNavigate } from 'react-router-dom';
import { useQueryAdapter } from '../../../hooks/useQueries';
import { useTranslator } from '../../../hooks/useTranslator';
import ArrowBack from '../../../assets/icons/arrow_back.svg';
import HistoryIcon from '../../../assets/icons/watch_later.svg';
import HistoryEmpty from "../../../assets/icons/history_toggle_off.svg";
import Icon from '../../icon/icon';
import { ChatInput } from '../chat-input';
export const useHistory = ({ slug, route }) => {
    const navigate = useNavigate();
    const { data, isLoading } = useQueryAdapter({
        name: `getHistory` + slug,
        data: slug,
        fnquery: getSessionsByUseCase,
    });
    const toggleView = useCallback(
        (id, data) => {
            const { session_id } = data ?? {};
            if (session_id) {
                navigate(`${route}=${session_id}`, { replace: false });
            }
        },
        [navigate, route]
    );

    return { data, isLoading, toggleView };
};

export const HistoryEmptyComponent = () => {
    const { t } = useTranslator();
    return (
        <div className="history_empty h-full">
            <img src={HistoryEmpty} alt="empty" />
            <p className="blue-text">{t("historialTituloVacio")}</p>
        </div>)
}

export const HistoryRequest = ({ slug, route }) => {
    const { data: history, toggleView, isLoading } = useHistory({ slug, route });
    if (isLoading) return <div className='w-full h-full flex justify-center items-center'>...</div>
    if (!history?.length) return <HistoryEmptyComponent />
    return <UseCaseHistory
        containerClassName='h-full'
        history={history}
        sessionId={null}
        toggleView={toggleView}
    />
}

export const History = ({ slug, route }) => {
    const { t } = useTranslator();
    return (
        <div
            className={classNames(
                `w-full flex h-fit overflow-hidden flex-col gap-4 bg-DarkBlue-700/90 sm-max:bg-transparent rounded-4 pt-4 pb-4 max-w-[400px] max-h-[700px]`
            )}
        >
            <div className='flex w-full tabs flex-col h-full overflow-hidden justify-between text-shaiaBlue px-6'>
                <h6 className="blue-text sidebar-title">{t("historialTitulo")}</h6>
                <HistoryRequest slug={slug} route={route} />
            </div>
        </div>
    );
};

export const NavBarMobile = ({ children }) => {
    return (
        <div className='block lg:hidden w-screen h-fit bg-DarkBlue-700 px-4 flex flex-row gap-4 items-center justify-between rounded-tl-4 rounded-tr-4'>
            {children}
        </div>
    );
};

export const NavBarMobileHistory = ({ children, bindChat = {}, ChatInputComponent = ChatInput, slug, route }) => {
    const { t } = useTranslator();
    const navigate = useNavigate();
    const [showHistory, setShowHistory] = useState(false);
    const handleOnClickBack = () => {
        navigate('/', { replace: true });
    };
    const toggleClass = () => {
        setShowHistory(prev => !prev);
    };
    return (
        <NavBarMobile>
            <div className='flex flex-col w-full p-4'>
                <div className={classNames('flex flex-row justify-between w-full  overflow-y-auto items-center justify-center', {
                    'transition-all duration-300 ease-in-out transform h-fit max-h-[400px]': showHistory,
                    'transition-all duration-300 ease-in-out transform h-0': !showHistory,
                })}>
                    <HistoryRequest slug={slug} route={route} />
                </div>
                <ChatInputComponent {...bindChat} />
                <div className='flex flex-row justify-between'>
                    <Icon
                        icon={ArrowBack}
                        iconText={t('regresar')}
                        customClassName='gap-1 py-0 w-19 p-0 m-0'
                        onClick={handleOnClickBack}
                        disabledToolTip={true}
                    />
                    {children}
                    <Icon
                        icon={HistoryIcon}
                        iconText={'Historial'}
                        customClassName='gap-1 w-19 p-0 m-0'
                        onClick={toggleClass}
                        disabledToolTip={true}
                    />
                </div>
            </div>

        </NavBarMobile>
    );
};


// {isMobile && (
//     <div className="fixed z-sticky bottom-0 left-0 w-screen h-16 bg-DarkBlue-700 px-4 flex flex-row gap-4 items-center justify-between rounded-tl-4 rounded-tr-4">
//       <Icon
//         icon={ArrowBack}
//         iconText={t("regresar")}
//         customClassName="gap-1 py-0 w-19"
//         onClick={trackBackEvent}
//         disabledToolTip={true}
//       />
//       <Icon
//         icon={ChatIcon}
//         iconText={"Chat"}
//         customClassName="gap-1 py-0 w-19"
//         onClick={showChat}
//         disabledToolTip={true}
//       />
//       {!gptSuccess && (
//         <Icon
//           icon={History}
//           iconText={"Historial"}
//           customClassName="gap-1 w-19"
//           onClick={toggleClass}
//           disabledToolTip={true}
//         />
//       )}
//     </div>